import { AUTH_POST } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

export interface ExportLeadsRequest {
  type: "OFFLINE" | "MAIL";
  filter: {
    rules: any[];
    condition: "AND";
    limit?: number; // Made optional since email exports don't need limits
    skip: number;
    sortBy: string;
    sortOrder: string;
    search?: string; // Optional search parameter
  };
}

export const exportLeads = async (requestBody: ExportLeadsRequest): Promise<any> => {
  try {
    const url = new URL("/api/leads/export", config.baseURL);
    
    const response = await AUTH_POST(url.toString(), requestBody);
    return response;
  } catch (error) {
    console.error("Error exporting leads:", error);
    throw error;
  }
};

export interface ExportLeadsToEmailOptions {
  leadIds?: string[];        // Specific lead IDs to export (if not "select all")
  isAllSelected?: boolean;   // Whether "select all" was clicked
  filterRules?: any[];       // Current filter rules applied
  searchKey?: string;        // Current search query
  totalCount?: number;       // Total count of leads (used as limit when "select all")
}

// Specific function for email export
export const exportLeadsToEmail = async (options: ExportLeadsToEmailOptions = {}): Promise<any> => {
  try {
    const { leadIds = [], isAllSelected = false, filterRules = [], searchKey = "", totalCount } = options;

    // Build the filter rules
    let rules: any[] = [...filterRules];

    // Determine the limit:
    // - If "select all" is clicked, use the total count
    // - If specific leads are selected, use the number of selected leads
    // - Default to a large number to ensure all leads are exported
    let limit: number | undefined;
    
    if (isAllSelected && totalCount) {
      limit = totalCount;
    } else if (!isAllSelected && leadIds.length > 0) {
      limit = leadIds.length;
      rules = [
        {
          field: "_id",
          operator: "in",
          value: leadIds
        }
      ];
    }

    const requestBody: ExportLeadsRequest = {
      type: "MAIL",
      filter: {
        rules,
        condition: "AND",
        skip: 0,
        ...(limit && { limit }),
        sortBy: "CREATED_AT",
        sortOrder: "desc",
        ...(searchKey && { search: searchKey })
      }
    };

    const url = new URL("/api/leads/export", config.baseURL);
    
    // Make the request - AUTH_POST will throw an error if status is not 2xx
    const response = await AUTH_POST(url.toString(), requestBody);
    
    // If we reach here, the request was successful (200 status)
    // The response will be an empty array [] but that's expected
    return { success: true, data: response };
  } catch (error) {
    console.error("Error exporting leads to email:", error);
    throw error;
  }
};
